// Simple Font Management System
export const FONTS = {
  roboto: 'font-roboto',
  poppins: 'font-poppins', 
  openSans: 'font-openSans',
  lato: 'font-lato',
  montserrat: 'font-montserrat',
  nunito: 'font-nunito',
  playfair: 'font-playfair',
  merriweather: 'font-merriweather',
  fira: 'font-fira',
  sourceCode: 'font-sourceCode',
} as const;

// Font family names for inline styles with proper fallbacks
export const FONT_FAMILIES = {
  roboto: 'Roboto, sans-serif',
  poppins: 'Poppins, sans-serif', 
  openSans: '"Open Sans", sans-serif',
  lato: 'Lato, sans-serif',
  montserrat: 'Montserrat, sans-serif',
  nunito: 'Nunito, sans-serif',
  playfair: '"Playfair Display", serif',
  merriweather: 'Merriweather, serif',
  fira: '"Fira Code", monospace',
  sourceCode: '"Source Code Pro", monospace',
} as const;

export type FontKey = keyof typeof FONTS;

// Simple function to get Tailwind font class
export const getTailwindFontClass = (fontKey: FontKey): string => {
  return FONTS[fontKey] || FONTS.poppins;
};

// Function to get actual font family name for inline styles
export const getFontFamily = (fontKey?: FontKey | string): string => {
  if (!fontKey) {
    return FONT_FAMILIES.poppins;
  }
  
  // Check if fontKey is a valid key in FONT_FAMILIES
  if (fontKey in FONT_FAMILIES) {
    return FONT_FAMILIES[fontKey as FontKey];
  }
  
  // Fallback to poppins if invalid key
  return FONT_FAMILIES.poppins;
};

// Simple function for navigation widgets
export const getFontUtilities = (fontFamily?: string, defaultFont: string = 'poppins') => {
  const fontKey = (fontFamily && fontFamily in FONTS) ? fontFamily as FontKey : defaultFont as FontKey;
  const tailwindFontClass = getTailwindFontClass(fontKey);
  const actualFontFamily = getFontFamily(fontKey);
  
  return {
    fontKey,
    effectiveFontFamily: actualFontFamily,
    fontStyle: { fontFamily: actualFontFamily },
    tailwindFontClass
  };
};
